export default __webpack_public_path__ + "static/media/banner-arrow.9a81e4c7.svg";